import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';
declare var $: any;

@Component({
    selector: 'app-ficheclt-contact',
    templateUrl: './ficheclt-contact.component.html',
    styleUrls: ['./ficheclt-contact.component.css'],
    standalone: false
})
export class FichecltContactComponent implements OnInit, OnChanges {
  @Input() detail;
  @Input() isedit: Boolean;
  @Input() add: Boolean;
  @Input() listContactCliendAlreadyLoaded: Boolean;
  @Input() isDepuisFicheChantier: Boolean;
  
  @Output() show = new EventEmitter<any>();
  @Output() persistContactClient = new EventEmitter<any>();

  factauto = {};
  avoirAuto = {};
  selected = [];
  dataArticle = [];
  edit: Boolean;
  listChantier = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  listeAgence = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  listeCommercial = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  listCivilite = [];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  condition1: Boolean = false;
  condition2: Boolean = false;
  condition3: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  adresseAchat: Boolean = false;
  isHisto: Boolean = false;
  devise;
  pays = '';
  focusIndex = 0;
  frequence = [
    { id: '1', libelleObjetEntite: 'Mensuelle' },
    { id: '2', libelleObjetEntite: 'Trimestrielle' },
    { id: '3', libelleObjetEntite: 'Semestrielle' },
    { id: '6', libelleObjetEntite: 'Bimestrielle' },
    { id: '4', libelleObjetEntite: 'Annuelle' },
  ];

  listeContact = [];
  listeContactHisto = [];
  tempClient: any = {};
  listChampSupp = [];
  contactSelected = {};
  listChampsClientSupp = [];
  @ViewChild('champSupp') champSupp;

  constructor(public common: CommonService, private modalService: BsModalService) {
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.devise = this.common.local.getObject('paramSociete').devise;
    this.adresseAchat = this.common.local.getObject('paramSociete').adresseAchat;
  }

  ngOnInit() {
    this.tempClient = Object.assign({}, this.detail);
    this.listChampSupp = this.common.getType('typeChampsupp') || [];
    this.searchCivilite();
    this.getListeCommercial();
    this.isEmpty = false;
    const ctrl = this;
    console.log(this.isedit)
    
    this.chargerContactClient().then(datas => {
        ctrl.persistContactClient.emit();
        if(datas.data) {            
            let listContact = [];
            let listContactHisto = [];
            
            if(this.isDepuisFicheChantier) {
                if(this.detail.id) {
                    listContact = datas.data[0];
                    listContactHisto = datas.data[1];
                }
            } else {
                listContact = datas.data['listContact'] || [];
                listContactHisto = datas.data['listContactHisto'] || [];
            }
            
            ctrl.detail['listContact'] = listContact;
            ctrl.detail['listContactHisto'] = listContactHisto;
        }
        
        if (this.detail['listContact']) {
          this.detail['listContact'].forEach(elt => this.listeContact.push(Object.assign({}, elt)));
          this.listeContact = [...this.listeContact];
          this.listeContact.forEach(elt => {
            elt.civilite = elt.civilite || this.listCivilite[0];
            elt.commercial = elt.commercial || this.listeCommercial[0];
            elt.chantier = elt.chantier || this.listChantier[0];

            if (elt.chantier) {
              elt.chantier.libelleObjetEntite = elt.chantier.numChantier + (elt.chantier.responsable ? ' / ' + elt.chantier.responsable : '') +
                (elt.chantier.ville ? ' / ' + elt.chantier.ville : '') + (elt.chantier.telephone ? ' / ' + elt.chantier.telephone : '');
            }

            if (elt.commercial) {
              const u = this.common.getObjetById(this.common.getType('typeCom'), elt.commercial.id);
              if (u) {
                elt.commercial = u;
              } else {
                elt.commercial.libelleObjetEntite = 'Tous';
              }
            }
          });
        }

        if (this.detail['listContactHisto']) {
          this.detail['listContactHisto'].forEach(elt => this.listeContactHisto.push(Object.assign({}, elt)));
          this.listeContactHisto = [...this.listeContactHisto];
          this.listeContactHisto.forEach(elt => {
            elt.civilite = elt.civilite || this.listCivilite[0];
            elt.commercial = elt.commercial || this.listeCommercial[0];
            elt.chantier = elt.chantier || this.listChantier[0];

            if (elt.chantier) {
              elt.chantier.libelleObjetEntite = elt.chantier.numChantier + (elt.chantier.responsable ? ' / ' + elt.chantier.responsable : '') +
                (elt.chantier.ville ? ' / ' + elt.chantier.ville : '') + (elt.chantier.telephone ? ' / ' + elt.chantier.telephone : '');
            }

            if (elt.commercial) {
              const u = this.common.getObjetById(this.common.getType('typeCom'), elt.commercial.id);
              if (u) {
                elt.commercial = u;
              } else {
                elt.commercial.libelleObjetEntite = 'Tous';
              }
            }
          });
        }
    });
  }
  
  chargerContactClient() {
      if(this.listContactCliendAlreadyLoaded ||
          (this.isDepuisFicheChantier && (!this.detail.id))) {
          return Promise.resolve(true);
      } else {        
        let param;
        if(this.isDepuisFicheChantier) {
            param = {
              'servlet': 'DBGestionContact',
              'module': 'Recylog',
              'type': 'map',
              'compression': 'true',
              'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 7
                },
                'CLEF_CHANTIER': {
                    'typeParam': 'int',
                    'valeur': this.detail['id']
                }
              }
            };            
        } else {      
            this.detail['nomclass'] = 'Client';
            param = {
              'servlet': 'DBGestionContact',
              'module': 'Recylog',
              'type': 'map',
              'compression': 'true',
              'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 6
                },
                'CLIENT': this.detail
              }
            };
        }

        return this.common.post('', { param: param });     
      } 
  }

  ngOnChanges(changes) {
      // console.log(this.isedit)
  }

  hideContact() {
    this.show.emit();
  }

  selectRow(row) {
    this.focusIndex = this.listeContact.indexOf(row);
    this.selected = [row];
  }

  deleteLigne(row) {
    const temp = this.listeContact.filter(elt => elt !== row);
    this.listeContact = temp;
    this.listeContactHisto.push(row);
    this.updateObjetClient();
  }

  addLigne() {
    this.contactSelected = {
      index: this.listeContact.length, /* id: '1', */
      civilite: this.listCivilite[0],
      commercial: this.listeCommercial[0],
      chantier: this.listChantier[0]
    };
    if (this.detail['prospectHolding']) {
      this.contactSelected['client'] = {
        id: this.detail['id']
      }
    }

    this.edit = true;
    this.add = true;
  }

  searchCivilite(event?) {
    this.listCivilite = [{ id: 0, libelleObjetEntite: 'Aucune' }];
    this.common.getType('typeCivilite').forEach(elt => {
      elt.libelleObjetEntite = elt.libelle;
      this.listCivilite.push(elt);
    });
  }

  // commercial combo : + tous

  searchCommercial(type) {
    const param = {
      'servlet': 'DBGetListUserByFonction',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': {
        'typeParam': 'int',
        'valeur': type
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const tab = datas.data;
        const liste = [];
        for (const i in tab[0]) {
          if (tab[1].length && tab[0].length) {
            liste.push({ id: parseInt(tab[1][i], 10), libelle: tab[0][i], libelleObjetEntite: tab[0][i] });
          }
        }
        this.listeCommercial.push(...liste);
        this.listeCommercial = [...this.listeCommercial];

        this.listeCommercial.forEach(c => {
          const co = this.common.getObjetById(this.common.getType('typeCom'), c.id);
          if (co) {
            c['libelleObjetEntite'] = co['libelle'];
          }
        });
      }
    });
  }

  getListeCommercial() {
    this.searchCommercial(1).then(() => {
      this.searchCommercial(4);
    });
  }

  // champ Supp => ContactClient.listChampsClientSupp = var global 47

  changeFiliere() {
    // this. = [];
    this.listChampsClientSupp = [];
    this.listChampSupp.forEach(elt => {
      if (elt.actif) {
        const FiliereFact = {
          id: elt.id,
          nom: elt.nom,
          valeur: elt.valeur,
          contactClient: {
            id: this.contactSelected['id'] || 0
          }
        };
        this.listChampsClientSupp.push(FiliereFact);
      }
    });

  }

  getValueChampsupp(id) {
    let item;
    if (this.detail.ChampsClientSupp) {
      this.detail.ChampsClientSupp.filter(elt => {
        if (parseInt(elt.clefChampsClientSupp, 10) === parseInt(id, 10)) {
          item = elt;
        }
      });
    }
    return item ? item.valeur : '';
  }

  validerChampSupp() {
    this.contactSelected['listChampsClientSupp'] = this.listChampSupp || [];
    this.contactSelected['listChampsClientSupp'] = this.contactSelected['listChampsClientSupp'].filter(c => c.actif);
  }

  getChampsCltSupp(row) {
    this.contactSelected = row;
    this.listChampSupp = this.common.getType('typeChampsupp') || [];
    const param = {
      'servlet': 'DBGestionChampsClientSupp',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CONTACT_CLIENT': {
          'typeParam': 'int',
          'valeur': row.id || 0
        },
      }
    };
    if (!row['listChampsClientSupp'] && row.id) {
      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          this.listChampSupp.forEach(elt => {
            elt['contactClient'] = { id: row.id };
            elt.clefChampsClientSupp = elt.id;
            datas.data = datas.data || [];
            datas.data.forEach(champ => {
              if (parseInt(champ.clefChampsClientSupp, 10) === elt.id) {
                elt.actif = true;
                elt.valeur = champ.valeur;
              }
            });
          });
          this.common.openModal(this.modalService, this.champSupp);
        }
      });
    } else {
      this.listChampSupp.forEach(elt => {
        elt['contactClient'] = { id: row.id };
        elt.clefChampsClientSupp = elt.id;
        row['listChampsClientSupp'] = row['listChampsClientSupp'] || [];
        row['listChampsClientSupp'].forEach(champ => {
          if (parseInt(champ.clefChampsClientSupp, 10) === elt.id) {
            elt.actif = true;
            elt.valeur = champ.valeur;
          }
        });
      });
      this.common.openModal(this.modalService, this.champSupp);
    }
  }

  searchChantier(event) {
    this.listChantier = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
    if (!this.detail['prospectHolding']) {
      const param = {
        'servlet': 'DBGetChantierClient',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'SITE': {
            'typeParam': 'int',
            'valeur': this.common.user[2]
          },
          'CLEF_CLIENT': {
            'typeParam': 'int',
            'valeur': this.detail['id']
          },
          'CRITERE': event || ''
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        // $('#autocomplete').trigger('click');
        if (this.common.verifySession(datas)) {
          datas.data.forEach(ch => {
            ch.libelle = ch.numChantier + (ch.responsable ? ' / ' + ch.responsable : '') +
              (ch.ville ? ' / ' + ch.ville : '') + (ch.telephone ? ' / ' + ch.telephone : '');
            ch.libelleObjetEntite = ch.libelle;
            this.listChantier.push(ch);
          });
        }
      });
    } else {
      this.detail['nomclass'] = 'Client';
      const param = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 7
        },
        'CLIENT': this.detail,
        'HOLDING_SERVLET': 'DBGestionProspect',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'false',
        'CRITERE_CHANTIER': event || ''
      };
      return this.common.DBGestionAppelHolding(param).then(datas => {
        // $('#autocomplete').trigger('click');
        if (this.common.verifySession(datas)) {
          datas.data['listChantier'] = datas.data['listChantier'] || [];
          datas.data['listChantier'].forEach(elt => {
            if (elt.dateFin) {
              elt.dateFin = moment(elt.dateFin, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
            this.listChantier.push(elt);
          });
        }
      });
    }

  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  updateObjetClient() {
    this.detail['listContact'] = this.listeContact;
    // this.hideContact();
  }

  editer(row) {
    if (this.detail['prospectHolding']) {
      const nombd = this.common.local.getObject('nomBDHolding') ? this.common.local.getObject('nomBDHolding').nomBDHolding : '';
      this.contactSelected['nomclass'] = 'ContactClient';
      this.detail['nomclass'] = 'Client';
      const paramChantier = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'HOLDING_SERVLET': 'DBGestionContact',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'true',
        'CLEF_CONTACT_CLIENT': {
          'typeParam': 'int',
          'valeur': row.id
        },
        'BD_HOLDING': nombd,
        'IS_PROSPECT_HOLDING': {
          'typeParam': 'boolean',
          'valeur': true
        },
      };
      return this.common.DBGestionAppelHolding(paramChantier).then(datas => {
        if (datas.data && datas.data !== null) {
          this.contactSelected = datas.data || row;
          this.contactSelected['chantier'] = this.contactSelected['chantier'] ? this.contactSelected['chantier'] : this.listChantier[0];
          this.contactSelected['commercial'] = this.contactSelected['commercial'] ?
           this.contactSelected['commercial'] : this.listeCommercial[0];
          this.contactSelected['civilite'] = this.contactSelected['civilite'] ? this.contactSelected['civilite'] : this.listCivilite[0];
          this.edit = true;
        }
      });
    } else {
      this.contactSelected = row;
      this.edit = true;
    }
  }

  hideFenetreContact() {
    this.edit = false;
  }

  validerFenetreContact() {
    if (this.detail['prospectHolding']) {
      this.contactSelected['id'] = this.contactSelected['id'] || 0;
      this.contactSelected['nomclass'] = 'ContactClient';
      this.detail['nomclass'] = 'Client';
      this.contactSelected['client'] = {
        id: this.detail['id'],
        prospectHolding : this.detail['prospectHolding'] || false,
        nomclass: 'Client'
      }
      const paramChantier = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 5
        },
        'HOLDING_SERVLET': 'DBGestionContact',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'true',
        'CONTACT_CLIENT': this.contactSelected,
        'CLIENT': this.detail,
      };
      return this.common.DBGestionAppelHolding(paramChantier).then(datas => {
        if (datas.data && datas.data !== null) {
          if (this.add) {
            this.contactSelected['id'] = datas.data || 0;
            this.listeContact.push(this.contactSelected);
          }

          this.updateObjetClient();
          this.edit = false;
          this.add = false;
        }
      });
    } else {
      if (this.add) {
        this.listeContact.push(this.contactSelected);
      }

      this.updateObjetClient();
      this.edit = false;
      this.add = false;
    }
  }

  choisirChantier(event) {
    this.contactSelected['chantier'] = event;
  }

  showHisto() {
    this.isHisto = !this.isHisto;
  }
}
